import { SubscriptionManager } from "@buildwithflux/repositories";
import { hasBrowserWindowAccess } from "@buildwithflux/shared";
import { set } from "lodash";
export const nodeToObject3DMapSubscriptionManager = new SubscriptionManager();
/** @deprecated use primitive store instead  */
export const NodeToObject3DMap = new Map();
/** @deprecated use primitive store instead  */
export const Object3DToNodeMap = new WeakMap();
/** @deprecated use primitive store instead  */
export function setNodeObject3DMapping(uid, obj3D) {
    NodeToObject3DMap.set(uid, obj3D);
    Object3DToNodeMap.set(obj3D, uid);
    nodeToObject3DMapSubscriptionManager.notify("added", uid);
}
/** @deprecated use primitive store instead  */
export function removeNodeObject3DMapping(uid, obj3D) {
    NodeToObject3DMap.delete(uid);
    Object3DToNodeMap.delete(obj3D);
    nodeToObject3DMapSubscriptionManager.notify("removed", uid);
}
// For cypress. See for example tracing.cy.ts
if (hasBrowserWindowAccess()) {
    set(window, ["__FLUX__", "NodeToObject3DMap"], NodeToObject3DMap);
}
//# sourceMappingURL=deprecatedMapping.js.map